export const AllAddOnConstants = {

    GET_ADD_ON: 'GET_ADD_ON', 
    ADD_ON_LOADING: 'ADD_ON_LOADING',
    GET_ADD_ON_ERROR: 'GET_ADD_ON_ERROR',
    
    EMPTY_ADD_ON:'EMPTY_ADD_ON'

};
